module.exports = __webpack_public_path__ + "static/media/vida_obligatorio.b66d3767.svg";